<template>
    <div >
      <b-form-group label="Phase Check List" style="">
        <b-form-checkbox-group
          v-model="selected"
          :options="checklist.items"
          name="checklist"
          value-field="id"
          text-field="text"
          stacked
          @input="emitCheckListStatus()">
          </b-form-checkbox-group>
      </b-form-group>
    </div>
</template>

<script>
    import axios from "axios"
    import { required, email, minLength, maxLength, numeric } from 'vuelidate/lib/validators'

  export default {
    data() {
      return {
          checklist: { },
          selected: [],
      }
    },
    props: {
        lifecycleStatus: [String],
        requestId: [Number]
    },
    validations: {
    },

       created() {
           this.loadChecklist();
       },

    methods: {
      async loadChecklist() {
         await axios.get(`${process.env.VUE_APP_API_BASE_URL}/checklist/config/${this.lifecycleStatus}/${this.requestId}`)
            .then(response => {
                this.checklist = response.data;
                this.checklist.items.forEach(item => {
                  if (item.checked) {
                    this.selected.push(item.id)
                  }
                })
            })
      },
      emitCheckListStatus(checked) {
        this.saveUpdate()
        this.$emit('checklist-update', this.selected.length == this.checklist.items.length)
      },
      saveUpdate() {
        this.checklist.items.forEach(item => {
          item.checked = this.selected.includes(item.id)
        })
        
        this.checklist.requestId = this.requestId

        axios.post(`${process.env.VUE_APP_API_BASE_URL}/checklist/save`, this.checklist)
            .then(response => {
            })
      }
  }
  }
</script>

<style scoped>
.form-group .col-form-label {
    font-weight: 750;
}
</style>